<template>
  <div class="row">
    <div class="col-4"></div>
    <div class="col-8">
      <div class="col-12 description">
        <p>{{ description }}</p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FormGroupDescriptionSection',
  props: {
    description: {
      type: String,
      required: true,
    },
  },

  data() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.description {
  margin-top: 10px;
    p{
      font-size: var(--fs-12);
      font-weight: 400;
      color: var(--text-neutral);
      margin: var(--space-0);
    }
  }
</style>
